import common from './common';
import Module from './module';
import Util from './lib/util';
import Mustache from 'mustache';
import $ from 'jquery';
import 'slick-carousel';

/**
 * @class SchoolHome
 * @extends {Module}
 */
class SchoolHome extends Module {

	constructor(options) {
		super(options);

		this.templates = {};
	}

	init() {
		return super.init().then(e => {
			let requests = [];

			requests.push(this.getPauseButtonTemplate());

			Promise.all(requests).then(() => this.emit('init'));
		});
	}

	main() {
		this.homeSlider();
		this.appendPauseBtn();
		
		// start slider paused
		$('.nha-btn-slider').toggleClass('play');
		$('.slick-slider').slick('slickPause');
	}

	appendPauseBtn() {
		let $heroSlider = $('.nha-hero-slider');
		let numberOfSlides = $heroSlider.find('.slick-slide:not(.slick-cloned)').length;

		if (numberOfSlides > 1) {
			// load pause btn html
			let btnHtml = this.templates.pauseBtn;
			$heroSlider.find('.slick-dots').append(btnHtml);

			// bind btn
			$('.nha-btn-slider').on('keydown', e => { if (e.which === 13) { e.preventDefault(); this.pausePlaySlider(e); } });
			$('.nha-btn-slider').on('click', e => { this.pausePlaySlider(e) });
		}
	}

	getPauseButtonTemplate() {
		return new Promise((resolve, reject) => {
			if (!Util.hasValue(this.templates.pauseBtn)) {
				return $.get(`/${common.getCultureCode()}/template/pause-button`, result => {
					if (!result.IsSuccess) return reject(result.Message);

					this.templates.pauseBtn = result.Data;
					Mustache.parse(this.templates.pauseBtn);

					resolve(this.templates.pauseBtn);
				}).catch(reject);
			} else {
				resolve(this.templates.pauseBtn);
			}
		})
	}

	homeSlider() {
		let $heroSlider = $('.nha-hero-slider');

		$heroSlider.slick({
			infinite: true,
			accessibility: true,
			autoplaySpeed: 6000,
			autoplay: true,
			dots: true,
			arrows: false,
			useTransform: true,
			slidesToShow: 1,
			variableWidth: false
		});

		// animation bug fix
		$heroSlider.on('setPosition', function (event, slick, currentSlide, nextSlide) {
			var slidesShown = $heroSlider.slick('slickGetOption', 'slidesToShow');
			var numberOfSlides = $heroSlider.find('.slick-slide').length;

			if (slidesShown === numberOfSlides) {
				$heroSlider.find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
			}
		});
	}

	pausePlaySlider(e) {
		let target = $(e.currentTarget);

		$(target).toggleClass('play');

		if ($(target).hasClass('play')) {
			$('.slick-slider').slick('slickPlay');
		}
		else {
			$('.slick-slider').slick('slickPause');
		}
	}
}

const schoolHome = new SchoolHome();

// initialize when common is ready
common.on('init', e => schoolHome.init())

export default schoolHome;


// WEBPACK FOOTER //
// ./wwwroot/js/app/school-home.js